module.exports = __webpack_public_path__ + "static/media/windows.b8584bcd.svg";